export const environment = {
  envName: 'staging',
  production: false,
  showPilotDisclaimer: true,
  apiV1: "/api/v1",
  apiUrl: "https://bb-testing.orthoplex.ca/"
};

